import { BigFiveResult } from '@models/big-five/big-five-result';
import { createAction, props } from '@ngrx/store';

export const loadBigFiveResults = createAction('[Big-Five] Load Results');
export const loadBigFiveResultsSuccess = createAction(
  '[Big-Five] Load Results Success',
  props<{ results: BigFiveResult[] }>()
);
